<ll-titulo>{{ "progreso.estadisticas.titulo" | t }}</ll-titulo>

<cui-section-headline>{{ "progreso.estadisticas.subtitulo1" | t }}</cui-section-headline>
<tabla-kpi-auto></tabla-kpi-auto>
<br />
<cui-section-headline>{{ "progreso.estadisticas.subtitulo2" | t }}</cui-section-headline>
<estadisticas-simple-auto [evaluacionTipos]="evaluacionTipos"></estadisticas-simple-auto>
